import React, { FC } from 'react';
import { Form, Switch, Tag, Typography } from '@duxton-web/ui';
import styled from 'styled-components';

import {
  ExperimentAssignmentStrategy,
  ExpFormField,
} from '../../../helper/consts';

interface TimeShuffleProps {
  onToggle?: (checked: boolean) => void;
}

const { Text } = Typography;

const TimeShuffle: FC<TimeShuffleProps> = ({ onToggle }) => {
  const form = Form.useFormInstance();
  const currentStrategyName = Form.useWatch(ExpFormField.STRATEGY.NAME, {
    form,
    preserve: true,
  });

  return (
    <Wrapper>
      <Header>
        <Switch
          size="small"
          style={{ width: 28 }}
          onChange={onToggle}
          checked={
            currentStrategyName ===
            ExperimentAssignmentStrategy.TIME_SLICE_SHUFFLE
          }
        />
        <div>Time shuffle</div>
        <Tag
          bordered={false}
          style={{
            backgroundColor: '#D9FCDE',
            color: '#00B14F',
            borderRadius: 4,
          }}
        >
          Recommended
        </Tag>
      </Header>
      <Text type="secondary" style={{ fontSize: 12 }}>
        Randomly shuffle the order of treatments upon experiment creation.
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  gap: 8px;
`;

export default TimeShuffle;
